import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {ModalController, ToastController} from '@ionic/angular';
import {BaseClass} from '../../../../classes/base';
import {QuestionConfig} from '../../../../interfaces/process-config.interface';
import {TranslationService} from '../../../../services/translation.service';
import {UtilService} from '../../../../services/util.service';
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';

@Component({
    selector: 'app-multi-selection-questions',
    templateUrl: './multi-selection-questions.component.html',
    styleUrls: ['./multi-selection-questions.component.scss', '../../question-types.component.scss'],
})
export class MultiSelectionQuestionsComponent extends BaseClass implements OnInit {
    public typeConfigDescriptionEnabled: boolean;
    
    @Input() question: QuestionConfig;
    @Input() formGroup: UntypedFormGroup;
    @Input() isManagerComment: boolean = false;
    @Input() descriptionTooltip: string = '';
    @Input() showRequiredBadge: (formGroup: UntypedFormGroup, index: number) => boolean;
    @Input() setTooltip: (question: QuestionConfig, vIndex: number) => boolean;
    @Input() openDescriptionConcept: (title: string, description: string, index: number) => boolean;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _modalController: ModalController,
        private _utilService: UtilService,
        private _configService: ConfigService
    ) {
        super(_toastController, _translationService);
    }

    ngOnInit() {
        this.typeConfigDescriptionEnabled = this._configService.settings.features.typeConfigDescriptionEnabled;
    }

    public isCheckedMultiselect(question: QuestionConfig, value: string): boolean {
        const fieldValue = this.formGroup.get('field' + question.currentIndex).value;
        return !!fieldValue && fieldValue.includes(value);
    }

    public setMultiSelectionValue(checked: boolean, value: string, key: string): void {
        const currentValue = this.formGroup.get(key).value;
        const newValue = checked ?
            currentValue === '' ? value : (currentValue != null ? currentValue + ';' + value : value) :
            this._removeSubstring(currentValue, value);

        this.formGroup.get(key).setValue(
            newValue
        );
    }

    public onMultiSelectionChange(event: Event, value: string, key: string): void {
        const checked = (event as CustomEvent)?.detail?.checked ?? false;
        this.setMultiSelectionValue(checked, value, key);
    }

    private _removeSubstring(completeString: string, subString: string): string {
        const splitted: Array<string> = completeString.split(';');
        return splitted.filter(
            str => str !== subString
        ).join(';');
    }
}
